module.exports = __webpack_public_path__ + "img/group_filter.29bec456.svg";